import {
  Box,
  Button,
  ButtonProps,
  Dialog,
  Image,
  InformationCircleIcon,
  Text,
} from 'components'
import { forceLight } from 'utils'
import { useDisclosure } from 'utils'
import packageJson from '../../package.json'
import explorerLogo from '../assets/explorer-logo.svg'

export default function AboutButton(props: ButtonProps) {
  const aboutDisclosure = useDisclosure()

  return (
    <>
      <Button leftIcon={<InformationCircleIcon />} onClick={aboutDisclosure.onOpen} {...props}>
        About
      </Button>

      <Box {...forceLight}>
        <Dialog
          placement="center"
          contentProps={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '50px' }}
          {...aboutDisclosure}
        >
          <Image src={explorerLogo} height="100px" />
          <Text>Version: {packageJson.version}</Text>
        </Dialog>
      </Box>
    </>
  )
}
